export default __webpack_public_path__ + "static/media/bjTWnds.e1ac8a9c.webp";